import {useState} from 'react';
import {useAuth} from 'contexts/AuthContext';
import {getDashboardSearchLimit} from 'api/search';
import {alertByError} from 'utils/alerts';

function useGetSearchInputLimit(filter = {}) {
  const [limit, setLimit] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const {getSession, handleLoginBySession} = useAuth();

  async function getLimit() {
    try {
      setIsLoading(true);
      // always get the new session to check updated plan
      const {token} = getSession();
      await handleLoginBySession(token);

      const {data} = await getDashboardSearchLimit(filter);

      setLimit(data);
    } catch (err) {
      document.activeElement.blur();
      await alertByError(err);
    } finally {
      setIsLoading(false);
    }
  }

  return {limit, getLimit, isLoading};
}

export default useGetSearchInputLimit;
